import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContainThreeHeader = styled.div`
  background-color: ${({ theme }) => theme.neutral.gray[800]};
  width: 100%;
  display: grid;
  grid-template-columns: 12em 1fr 1fr;
  grid-template-rows: 1fr;
`;
export const ContainFourHeader = styled.div`
  background-color: ${({ theme }) => theme.neutral.gray[800]};
  width: 100%;
  display: grid;
  grid-template-columns: 12em 1fr 1fr 1fr;
  grid-template-rows: 1fr;
`;
export const ItemHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  height: 44px;
`;
export const ContainThreeContent = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 14em 1fr 1fr;
  grid-template-rows: 1fr;
  justify-content: center;
  align-items: center;
  margin: 0 0.5em;
`;
export const ContainFourContent = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 14em 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  justify-content: center;
  align-items: center;
  margin: 0 0.5em;
`;
export const ItemContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  width: fit-content;
  height: 44px;

  input {
    width: 3em;
  }
  .MuiCheckbox-colorSecondary.Mui-checked {
    color: ${({ theme }) => theme.button.primary};
  }
`;
export const GeneralWrapper = styled.div`
  color: ${({ theme }) => theme.neutral.black};
  display: grid;
  grid-template-columns: 85px 50px;
  background: ${({ theme }) => theme.neutral.white};
  padding: 1em;
  font-size: 14px;
  align-items: center;
  border-radius: 5px;
  margin: 10px;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 2px 8px ${({ theme }) => theme.shadows.medium};
    transition: 0.5s;
    transform: translateY(-3px);
  }
`;
